import React from "react";

export default class Footer extends React.Component {
  render() {
    return (
      <footer>
        <p>Christopher O'Brien 2020</p>
      </footer>
    );
  }
}
